import React from 'react';

const ScrollToTop = () => {
  const scrollToTop = () => {
    window.scroll({top: 0, behavior: 'smooth'});
  };

  return (
    <div className='flex justify-end cursor-pointer mt-5'>
      <button 
        className="w-10 h-10 rounded-full cursor-pointer bg-[#27c4f4] text-white flex items-center justify-center shadow-md"
        onClick={scrollToTop}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7-7-7 7" />
        </svg>
      </button>
    </div>
  );
};

export default ScrollToTop; 